<template>
  <div>
    <div class="c-bar">
      <div class="c-bar__wrapper d-lg-flex justify-content-between align-items-center">
        <div v-if="path !== 'online-tutor'"
          class="c-city-selector w-100 position-relative">
          <Selector
            :key="'city-selector'"
            :title="'地區'"
            :multiple="true"
            :target-options="cityOptions"
            :max="5"
            :selected-value="citySelected"
            @change="setCityValue">
          </Selector>
        </div>

        <!--除了 課輔安親、補習班、運動場所、線上教育平台 以外都會有類型-->
        <div
          v-if="path !== 'after-school-care' && path !== 'tutor' && path !== 'sports' && path !== 'online-tutor'"
          class="w-100 position-relative">
          <Selector
            :key="'type-selector'"
            :title="'類型'"
            :multiple="true"
            :target-options="typeOptions"
            :selected-value="typeSelected"
            @change="setTypeValue">
          </Selector>
        </div>

        <!--只有 特殊教育學校、課輔安親、補習班、線上教育平台 有年齡-->
        <div v-if="path ==='special' || path ==='after-school-care' || path ==='tutor' || path ==='online-tutor'"
          class="w-100 position-relative">
          <Selector
            :key="'age-selector'"
            :title="'適合年齡'"
            :multiple="true"
            :target-options="ageOptions"
            :max="3"
            :selected-value="ageSelected"
            @change="setAgeValue">
          </Selector>
        </div>

        <!--只有 補習班、運動場所 有類型(分類)-->
        <div v-if="path ==='sports' || path ==='tutor'" class="w-100">
          <CategorySelector
            class="w-100"
            :key="'type-category-selector'"
            :type="'lesson'"
            :selector-title="'分類'"
            :path="path ==='sports' ? path : null"
            :max="5"
            :age-selected="ageSelected"
            :selected-value="categorySelected"
            @change="setCategoryValue"
          >
          </CategorySelector>
        </div>

        <!--除了 特殊教育學校、課輔安親、補習班、社區大學/推廣教育、運動場所 以外都會有特色-->
        <div v-if="path !== 'tutor' && path !== 'community-college' && path !== 'sports'" class="w-100 position-relative">
          <Selector
            :key="'feature-selector'"
            :title="path === 'online-tutor' ? '分類' : '特色'"
            :multiple="true"
            :target-options="featureOptions"
            :selected-value="featureSelected"
            @change="setFeatureValue">
          </Selector>
        </div>

        <!--只有 小學、國中、高中職 有語言-->
        <div v-if="path ==='primary' || path ==='junior' || path ==='senior'" class="w-100 position-relative">
          <Selector
            :key="'lang-selector'"
            :title="'語言'"
            :multiple="true"
            :target-options="langOptions"
            :max="3"
            :selected-value="langSelected"
            @change="setLangValue">
          </Selector>
        </div>

        <!--只有 高中職、大專院校 有學術群-->
        <div v-if="path === 'senior'" class="w-100">
          <CategorySelector
            class="w-100"
            :key="'department-category-selector'"
            :type="path"
            :selector-title="path === 'senior' ? '學群' : '學院科系'"
            :selected-value="departmentSelected"
            @change="setDepartmentValue"
          >
          </CategorySelector>
        </div>

        <div class="c-bar__cell position-relative">
          <div class="c-bar__cell-inner">
            <div class="c-bar__cell-body">
              <div class="c-bar__text">
                <div class="c-bar__title">關鍵字</div>
                <input class="c-bar__input" type="text" v-model="q" placeholder="請輸入關鍵字"
                  @keyup.enter="search"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="position-relative">
          <a href="javascript://" class="c-bar__btn" @click="search">
            <span v-if="isMobile">搜尋</span>
            <i class="fas fa-search pb-lg-1"></i>
          </a>
        </div>
      </div>

      <div class="d-flex justify-content-end align-items-center">
        <a href="javascript://" @click="clearAll" class="text-primary">
            <span class="me-1">
              清除條件
            </span>
          <i class="fas fa-rotate-right"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
const { reactive, toRefs, computed, onMounted, onUnmounted } = Vue;
import Selector from '../../components/front/search-bar/Selector';
import CategorySelector from '../../components/front/search-bar/CategorySelector';
import DatePicker from 'vue2-datepicker';
import mobileCheck from '../../services/utilities';

export default {
  name: 'org-search-bar-app',
  components: {
    Selector,
    CategorySelector,
    DatePicker,
  },
  setup() {
    const layoutState = reactive({
      path: u.data('path')
    });

    const state = reactive({
      citySelected: u.data('city') ?? [],
      typeSelected: u.data('orgType') ?? [],
      ageSelected: u.data('age') ?? [],
      categorySelected: u.data('category') ?? [],
      featureSelected: u.data('orgFeature') ?? [],
      langSelected: u.data('language') ?? [],
      departmentSelected: u.data('department') ?? [],
      q: u.data('q') ?? '',
      isMobile: null,
    });

    mobileCheck(state);

    const cityOptions = u.data('cityOptions');
    const typeOptions = u.data('orgTypeOptions');
    const ageOptions = u.data('ageOptions');
    const featureOptions = u.data('orgFeatureOptions');
    const langOptions = u.data('languageOptions');
    const departmentOptions = u.data('departmentOptions');
    let params = {};

    const setCityValue = (v) => {
      state.citySelected = v;
    };

    const setTypeValue = (v) => {
      state.typeSelected = setValue(v);
    };

    const setAgeValue = (v) => {
      state.ageSelected = setValue(v);
    };

    const setCategoryValue = (v) => {
      state.categorySelected = setValue(v);
    };

    const setFeatureValue = (v) => {
      state.featureSelected = setValue(v);
    };

    const setLangValue = (v) => {
      state.langSelected = setValue(v);
    };

    const setDepartmentValue = (v) => {
      state.departmentSelected = setValue(v);
    };

    const search = () => {
      params.q = state.q;

      // Validate

      // 補習班必填年齡
      // https://github.com/lyrasoft/edu099/issues/500
      if (layoutState.path === 'tutor' && isEmpty(state.ageSelected)) {
        Swal.fire('請選擇年齡', '請先勾選欲查詢的年齡後，再送出搜尋');
        return;
      }

      if (state.categorySelected.length) {
        params.category = JSON.stringify(state.categorySelected);
      }

      if (state.citySelected.length) {
        params.city = JSON.stringify(state.citySelected);
      }

      if (state.typeSelected.length) {
        params.orgType = JSON.stringify(state.typeSelected);
      }

      if (state.ageSelected.length) {
        params.age = JSON.stringify(state.ageSelected);
      }

      if (state.featureSelected.length) {
        params.orgFeature = JSON.stringify(state.featureSelected);
      }

      if (state.langSelected.length) {
        params.language = JSON.stringify(state.langSelected);
      }

      if (state.departmentSelected.length) {
        params.department = JSON.stringify(state.departmentSelected);
      }

      params.path = layoutState.path;

      window.location.href = u.route('org_list', params);
    };

    function isEmpty(value) {
      if (value == null) {
        return true;
      }

      if (Array.isArray(value)) {
        return value.length === 0;
      }

      if (typeof value === 'object') {
        return Object.values(value).length === 0;
      }

      return Boolean(value);
    }

    const clearAll = async () => {
      state.q = '';
      state.categorySelected = [];
      state.citySelected = [];
      state.ageSelected = [];
      state.dateRange = [];
      state.tagSelected = [];

      params.path = layoutState.path;

      window.location.href = u.route('org_list', params);
    };

    const setValue = (v) => {
      let res = [];
      v.map((e) => {
        res = res.concat(e);
      });

      return Array.from(new Set(res));
    };

    return {
      ...toRefs(layoutState),
      ...toRefs(state),

      cityOptions,
      typeOptions,
      ageOptions,
      featureOptions,
      langOptions,
      departmentOptions,

      // Function
      setCityValue,
      setTypeValue,
      setAgeValue,
      setCategoryValue,
      setFeatureValue,
      setLangValue,
      setDepartmentValue,
      search,
      clearAll,
    };
  }
};
</script>

<style scoped>
</style>
